// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"87":"10d1c732","260":"650873dc","288":"6d52ee77","315":"da3f87b5","496":"2ddf5733","661":"d6fcf911","688":"e4dc8894","827":"e8bc1ed9"}[chunkId] + ".js";
};